import React from 'react';

const About = () => {
    return (
        <section id='about'>
            <h2 className='section-header'>About Me</h2>
            <div className='travel about-me'>
                <img 
                    src={'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60'}
                    alt='wooden boat in a mountain lake'
                />
                <div>
                    <p>Like many people in the world, I love to travel. There's just something about the freedom I feel when it's just me and my trusty {<a rel='noopener noreferrer' target='_blank' href='https://www.tortugabackpacks.com/products/setout-travel-backpack?variant=748029476873'>Tortuga</a>} backpack, alone in a foreign place.</p>
                    <p>I have been lucky enough to make my way through 30+ countries throughout North America, Asia, Europe, and Australia.</p>
                    <p>Whether it's the dense jungles of Vietnam, the lush tulip fields of Holland, or the snow capped mountains of Alaska, I will always be looking for new places to visit.</p>
                </div>
            </div>
            <div className='coding about-me'>
                <div>
                    <p>Coding is one of my favorite things to do because it is a perfect blend between cold hard logic and endless creative possibility.</p>
                    <p>Figuring out how things work has always been my biggest fascination, and there's no better way to discover the mystical mechanisms of software than by learning how to create it yourself.</p>
                    <p>Even now, the more I am learning, the more I realize how little I know, which is a very exciting prospect!</p>
                </div>
                <img 
                    src={'https://images.unsplash.com/photo-1561736778-92e52a7769ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60'}
                    alt='wooden boat in a mountain lake'
                />
            </div>
            <div className='gaming about-me'>
                <img 
                    src={'https://images.unsplash.com/photo-1552820728-8b83bb6b773f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60'}
                    alt='wooden boat in a mountain lake'
                />
                <div>
                    <p>Gaming is truly my most effective form of stress relief. There's nothing more relaxing than sitting down, booting up my favorite games, and just focusing solely on the task at hand.</p>
                    <p>Any game, doesn't matter the genre. Action/Adventure, RPGs, Sports, Shooters, I will play them all.</p>
                    <p>There's a special place in my heart, though, for my favorite game of all time, {<a rel='noopener noreferrer' target='_blank' href='https://www.rocketleague.com/'>Rocket League</a>}.</p>
                </div>
            </div>
        </section>
    )
}

export default About;